import {Component, HostBinding, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {NavItem} from "../models/NavItem";

@Component({
  selector: 'cir-pub-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NavItemComponent implements OnInit {

  @Input() item: NavItem;
  @Input() additionalClasses: string;

  constructor() { }

  ngOnInit() {
  }

}
